import { createTransform } from "redux-persist";
import LS from "../../../utils/LocalStorage";
import { LocalStorageEnum } from "../../../utils/enums";

const EXPIRE_TIME = 12 * 60 * 60 * 1000; // Expires after 12 hours

export const customerShortIdExpireTransform = createTransform<
  string | undefined,
  string | { value: string; _persistedAt: number } | undefined
>(
  (inboundState) => {
    if (!inboundState) {
      return inboundState;
    }

    const wrapped = {
      value: inboundState as string,
      _persistedAt: Date.now(),
    };

    return wrapped as any;
  },

  (outboundState: any) => {
    if (!outboundState) {
      return outboundState;
    }

    if (typeof outboundState === "string") {
      return outboundState;
    }

    if (outboundState.value && outboundState._persistedAt) {
      const currentTime = Date.now();
      const age = currentTime - outboundState._persistedAt;

      if (age > EXPIRE_TIME) {
        return undefined;
      }

      // Clear localStorage values
      LS._delete(LocalStorageEnum.USER_NAME);
      LS._delete(LocalStorageEnum.PHONE_NUMBER);
      LS._delete(LocalStorageEnum.COUNTRY_CODE);

      // Clear customerShortId and related user data
      const newState = { ...outboundState };
      delete newState.customerShortId;
      delete newState._customerShortIdPersistedAt;

      // Clear phone number info and username
      newState.phoneNumberInfo = {
        phoneNumber: "",
        countryCode: "",
      };
      newState.username = undefined;

      return newState;
    }

    return outboundState;
  },

  { whitelist: ["customerShortId"] }
);
